import { call, put, takeLatest } from 'redux-saga/effects';
import {
    PREMIUM_PATIENT,
    loadedSlot, CREATE_SLOT
} from '../actions/premium.action';
import {Premium} from '../api/index';
import {toast} from "react-toastify";

export function* ListPremiumPatient(payload) {
    try {
        let premium = yield call(() => Premium.get(payload));
        yield put(loadedSlot(premium.data));
    } catch (err) {
        console.error(err)
        toast.error(err.response.data.message);
    }
}export function* createSlot(payload) {
    try {
        let slot = yield call(() => Premium.create(payload));
        yield put(loadedSlot(slot.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}
export function* watchPremiumPatient(){
    yield takeLatest(PREMIUM_PATIENT, ListPremiumPatient)
}
export function* watchCreateSlot(){
    yield takeLatest(CREATE_SLOT, createSlot)
}



// WEBPACK FOOTER //
// ./src/sagas/Premium.saga.js